export const GET_VIEW_USER_COMMON_DATA = "GET_VIEW_USER_COMMON_DATA";
